import { FunctionComponent, PropsWithChildren, useEffect, useState } from 'react';

import { ErrorStatusContext } from '.';
import { PaginaNaoEncontradaView } from '../views/PaginaNaoEncontradaView';
import { StatusCodes } from 'http-status-codes';
import { useLocation } from 'react-router-dom';

const ErrorStatusProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [errorStatus, setErrorStatus] = useState();
  const [errorPath, setErrorPath] = useState<string>();
  const { pathname } = useLocation();

  useEffect(() => {
    if (errorPath !== pathname) {
      setErrorStatus(undefined);
    }
  }, [pathname]);

  useEffect(() => {
    setErrorPath(pathname);
  }, [errorStatus]);

  function renderContent() {
    if (errorStatus === StatusCodes.NOT_FOUND) {
      return <PaginaNaoEncontradaView />;
    }
    return children;
  }

  const value = { setErrorStatus };

  return <ErrorStatusContext.Provider value={value}>{renderContent()}</ErrorStatusContext.Provider>;
};

export default ErrorStatusProvider;
